import { Routes } from '@angular/router';

export const AdminRoutes: Routes = []
